<template>
    <div class="codics-pdf-imgup-body">
        <div class="codics-pdf-imgup-body-list" ref="imgBox">
            <div class="iconfont codics-pdf-imgup-body-item" draggable="true" v-for="(item, index) in imgList"
                :key="item">
                <div class="codics-pdf-imgup-body-item-card">
                    <el-image class="codics-pdf-imgup-body-item-card-img" :src="'https://cdn.bosscaigou.com/' + item"
                        fit="cover"></el-image>
                </div>
                <div class="iconfont codics-pdf-imgup-body-item-delete" @click="imgList.splice(index, 1)">
                    &#xe84b;</div>
            </div>
        </div>
        <el-upload action="cdn.bosscaigou.com" accept=".jpg,.png,.webp" multiple :http-request="pickImg"
            :show-file-list="false">
            <el-button class="codics-pdf-imgup-body-add" type="warning" round plain ref="upButton"
                @click="projectState = true">上传图片</el-button>
        </el-upload>
        <el-button v-show="imgList.length > 0" style="right: 175px;" class="codics-pdf-imgup-body-add" type="success"
            round plain @click="addVisible = true">确认上传</el-button>
        <el-image v-show="imgList.length == 0"
            src="https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/img/%E6%9A%82%E6%97%A0%E5%86%85%E5%AE%B9.svg"
            fit="fill" class="codics-pdf-imgup-body-empty"></el-image>
        <!-- 添加表单 -->
        <el-dialog title="添加画册" :close-on-click-modal='false' :visible.sync="addVisible" width="80%">
            <el-form :model="addForm">
                <el-form-item label="画册名称" :label-width="formLabelWidth">
                    <el-input v-model="addForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="画册介绍（微信分享使用）" :label-width="formLabelWidth">
                    <el-input v-model="addForm.desc" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="画册封面（微信分享使用）" :label-width="formLabelWidth">
                    <el-upload class="codics-firm-book-upload-dialog-himg-uploador" action="cdn.bosscaigou.com"
                        list-type="picture-card" multiple :http-request="uploadFile2"
                        :style="{ '--dataSize': addForm.himg == '' ? 'inline-block' : 'none' }">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="addPdfFuc();">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Sortable from 'sortablejs';
import * as qiniu from 'qiniu-js';
import { getQiNiuToken, addPdf } from '@/api';
import { randomString } from '@/utils/myutils';
import { hex_md5 } from '@/utils/md5';
export default {
    data() {
        return {
            addForm: {
                name: '',
                desc: '',
                himg: ''
            },
            formLabelWidth: '110px',
            imgList: [],
            addVisible: false,
            qiNiuInfo: {
                token: null
            },
        }
    },
    mounted() {
        this.getTokenFuc();
        this.initEngineSort();
    },
    methods: {
        async getTokenFuc() {
            let data = await getQiNiuToken();
            if (data.code == 200) {
                this.qiNiuInfo.token = data.uptoken;
            } else {
                this.$message.error(data.message);
            }
        },
        async pickImg(fileInfo) {

            const loading = this.$loading({
                lock: true,
                text: '上传中(0%)...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const _that = this;
            // 上传文件
            const observer = {
                next(res) {
                    // console.log('next: ', res)
                    loading.text = '上传中(' + res.total.percent.toFixed(2) + "%)...";

                },
                error(err) {
                    // console.log(err)
                },
                complete(res) {
                    // console.log('complete: ', res)
                    _that.imgList.push(res.key);
                    loading.close();
                }
            }
            const observable = qiniu.upload(fileInfo.file, 'huayuan/img/' + hex_md5(fileInfo.file.name) + randomString(10) + '_' + new Date().getTime()  + '.jpg', this.qiNiuInfo.token, {}, {

            })
            const subscription = observable.subscribe(observer) // 上传开始
        },
        initEngineSort() {
            // 支持拖拽排序
            const el = this.$refs.imgBox;
            this.sortAble = Sortable.create(el, {
                animation: 200,
                disabled: false,
                onStart: (e) => {
                    // e.item.classList.add('moving');
                    // flip = new Flip(el.children, 0.5);
                },
                onEnd: (e) => {
                    const { oldIndex, newIndex } = e;
                    // 交换位置
                    const arr = this.imgList;
                    const page = arr[oldIndex];
                    arr.splice(oldIndex, 1);
                    arr.splice(newIndex, 0, page);
                    // e.item.classList.remove('moving');
                }
            });

        },
        uploadFile2(uploadInfo) {

            let imgPath = 'huayuan/img/' + randomString(10) + '_' + new Date().getTime() + '_' + this.userInfo?.user?.id + '.png';

            const _that = this;
            // 上传文件
            const observer2 = {
                next(res) {
                    // console.log('next: ', res)
                },
                error(err) {
                    // console.log(err)
                },
                complete(res) {
                    // console.log('complete: ', res)
                    _that.addForm.himg = res.key;

                }
            }
            // console.log(uploadInfo.file);
            const observable2 = qiniu.upload(uploadInfo.file, imgPath, this.qiNiuInfo.token, {}, {
            })
            const subscription2 = observable2.subscribe(observer2) // 上传开始
            // console.log(subscription);
            // subscription2.unsubscribe() // 上传取消
        },
        async addPdfFuc() {

            if (this.addForm.name == '' || this.addForm.desc == '') {

                //请先获取上传Token
                this.$message({
                    showClose: true,
                    message: '画册的名称以及画册介绍不能为空！',
                    type: 'warning'
                });

                return;

            }

            this.addForm.url = this.imgList.join(",");

            if (this.addForm.himg == '') {
                //请先获取上传Token
                this.$message({
                    showClose: true,
                    message: '请先上传画册封面！',
                    type: 'warning'
                });

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await addPdf(this.addForm);

            loading.close();

            if (data.code == 200) {
                this.$message({
                    message: '添加画册成功！',
                    type: 'success'
                });
                setTimeout(() => {

                    window.location.reload();

                }, 300);
            } else {
                this.$message.error(data.message);
            }
            this.bookVisible = false;
        }
    }
}
</script>

<style>
.codics-pdf-imgup-body {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: #FFF;
    overflow: hidden;
}

.codics-pdf-imgup-body-empty {
    height: 160px;
    width: 160px;
    position: absolute !important;
    margin: auto;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
}

.codics-pdf-imgup-body-add {
    position: fixed !important;
    bottom: 35px;
    right: 55px;
    box-shadow: 3px 3px 9px rgba(0, 0, 0, .2);
}

.codics-pdf-imgup-body-item {
    height: 220px;
    width: 10%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
}

.codics-pdf-imgup-body-item-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
    border: 1px solid #EEE;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .2);
    pointer-events: none;
}

.codics-pdf-imgup-body-list {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    padding: 10px;
    box-sizing: border-box;
    overflow-y: scroll;
}

.codics-pdf-imgup-body-item-card-img {
    height: 100%;
    width: 100%;
    position: relative !important;
    float: left;
    box-sizing: border-box;
    overflow: hidden !important;
}

.codics-pdf-imgup-body-item-delete {
    height: 10px;
    width: 10px;
    position: absolute;
    margin: auto;
    top: 0;
    right: 0;
    pointer-events: all;
    cursor: pointer;
}
</style>